import { Route } from "@angular/router";
import { Permissions } from "../../../access/shared/authorization/permissions";
import { DavParamComponent } from "./dav-param.component";
import { DavParamEditRouting } from "./dav-param-edit/dav-param-edit-routing";
import { DavParamEditComponent } from "./dav-param-edit/dav-param-edit.component";
import { DavParamListRouting } from "./dav-param-list/dav-param-list-routing";

export const DavParamRouting: Route = {
    path: "dav-param",
    component: DavParamComponent,
    children: [        {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
        {
            path:'create',
            component: DavParamEditComponent,
            data: {
                breadcrumb: "Création"
            }
        },
        DavParamListRouting,
        DavParamEditRouting
    ],
    data: {
        'role': [
            Permissions.ROLE_ADMINISTRATION,
            Permissions.ROLE_DAV
        ],
        breadcrumb: "Paramètres DAV"
    },
}
